import { commonjsGlobal as P, getDefaultExportFromCjs as Q } from "../../../../../_virtual/_commonjsHelpers.js";
import { __module as z } from "../../../../../_virtual/dayjs.min.js";
(function(E, R) {
  (function(L, b) {
    E.exports = b();
  })(P, function() {
    var L = 1e3, b = 6e4, N = 36e5, A = "millisecond", p = "second", S = "minute", w = "hour", M = "day", T = "week", l = "month", U = "quarter", y = "year", _ = "date", J = "Invalid Date", V = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, q = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, B = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, k = function(r, e, t) {
      var i = String(r);
      return !i || i.length >= e ? r : "" + Array(e + 1 - i.length).join(t) + r;
    }, G = { s: k, z: function(r) {
      var e = -r.utcOffset(), t = Math.abs(e), i = Math.floor(t / 60), n = t % 60;
      return (e <= 0 ? "+" : "-") + k(i, 2, "0") + ":" + k(n, 2, "0");
    }, m: function r(e, t) {
      if (e.date() < t.date())
        return -r(t, e);
      var i = 12 * (t.year() - e.year()) + (t.month() - e.month()), n = e.clone().add(i, l), u = t - n < 0, s = e.clone().add(i + (u ? -1 : 1), l);
      return +(-(i + (t - n) / (u ? n - s : s - n)) || 0);
    }, a: function(r) {
      return r < 0 ? Math.ceil(r) || 0 : Math.floor(r);
    }, p: function(r) {
      return { M: l, y, w: T, d: M, D: _, h: w, m: S, s: p, ms: A, Q: U }[r] || String(r || "").toLowerCase().replace(/s$/, "");
    }, u: function(r) {
      return r === void 0;
    } }, x = "en", v = {};
    v[x] = B;
    var I = function(r) {
      return r instanceof j;
    }, W = function(r, e, t) {
      var i;
      if (!r)
        return x;
      if (typeof r == "string")
        v[r] && (i = r), e && (v[r] = e, i = r);
      else {
        var n = r.name;
        v[n] = r, i = n;
      }
      return !t && i && (x = i), i || !t && x;
    }, c = function(r, e) {
      if (I(r))
        return r.clone();
      var t = typeof e == "object" ? e : {};
      return t.date = r, t.args = arguments, new j(t);
    }, a = G;
    a.l = W, a.i = I, a.w = function(r, e) {
      return c(r, { locale: e.$L, utc: e.$u, x: e.$x, $offset: e.$offset });
    };
    var j = function() {
      function r(t) {
        this.$L = W(t.locale, null, !0), this.parse(t);
      }
      var e = r.prototype;
      return e.parse = function(t) {
        this.$d = function(i) {
          var n = i.date, u = i.utc;
          if (n === null)
            return /* @__PURE__ */ new Date(NaN);
          if (a.u(n))
            return /* @__PURE__ */ new Date();
          if (n instanceof Date)
            return new Date(n);
          if (typeof n == "string" && !/Z$/i.test(n)) {
            var s = n.match(V);
            if (s) {
              var o = s[2] - 1 || 0, f = (s[7] || "0").substring(0, 3);
              return u ? new Date(Date.UTC(s[1], o, s[3] || 1, s[4] || 0, s[5] || 0, s[6] || 0, f)) : new Date(s[1], o, s[3] || 1, s[4] || 0, s[5] || 0, s[6] || 0, f);
            }
          }
          return new Date(n);
        }(t), this.$x = t.x || {}, this.init();
      }, e.init = function() {
        var t = this.$d;
        this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
      }, e.$utils = function() {
        return a;
      }, e.isValid = function() {
        return this.$d.toString() !== J;
      }, e.isSame = function(t, i) {
        var n = c(t);
        return this.startOf(i) <= n && n <= this.endOf(i);
      }, e.isAfter = function(t, i) {
        return c(t) < this.startOf(i);
      }, e.isBefore = function(t, i) {
        return this.endOf(i) < c(t);
      }, e.$g = function(t, i, n) {
        return a.u(t) ? this[i] : this.set(n, t);
      }, e.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, e.valueOf = function() {
        return this.$d.getTime();
      }, e.startOf = function(t, i) {
        var n = this, u = !!a.u(i) || i, s = a.p(t), o = function(O, $) {
          var D = a.w(n.$u ? Date.UTC(n.$y, $, O) : new Date(n.$y, $, O), n);
          return u ? D : D.endOf(M);
        }, f = function(O, $) {
          return a.w(n.toDate()[O].apply(n.toDate("s"), (u ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice($)), n);
        }, h = this.$W, d = this.$M, g = this.$D, m = "set" + (this.$u ? "UTC" : "");
        switch (s) {
          case y:
            return u ? o(1, 0) : o(31, 11);
          case l:
            return u ? o(1, d) : o(0, d + 1);
          case T:
            var Y = this.$locale().weekStart || 0, H = (h < Y ? h + 7 : h) - Y;
            return o(u ? g - H : g + (6 - H), d);
          case M:
          case _:
            return f(m + "Hours", 0);
          case w:
            return f(m + "Minutes", 1);
          case S:
            return f(m + "Seconds", 2);
          case p:
            return f(m + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, e.endOf = function(t) {
        return this.startOf(t, !1);
      }, e.$set = function(t, i) {
        var n, u = a.p(t), s = "set" + (this.$u ? "UTC" : ""), o = (n = {}, n[M] = s + "Date", n[_] = s + "Date", n[l] = s + "Month", n[y] = s + "FullYear", n[w] = s + "Hours", n[S] = s + "Minutes", n[p] = s + "Seconds", n[A] = s + "Milliseconds", n)[u], f = u === M ? this.$D + (i - this.$W) : i;
        if (u === l || u === y) {
          var h = this.clone().set(_, 1);
          h.$d[o](f), h.init(), this.$d = h.set(_, Math.min(this.$D, h.daysInMonth())).$d;
        } else
          o && this.$d[o](f);
        return this.init(), this;
      }, e.set = function(t, i) {
        return this.clone().$set(t, i);
      }, e.get = function(t) {
        return this[a.p(t)]();
      }, e.add = function(t, i) {
        var n, u = this;
        t = Number(t);
        var s = a.p(i), o = function(d) {
          var g = c(u);
          return a.w(g.date(g.date() + Math.round(d * t)), u);
        };
        if (s === l)
          return this.set(l, this.$M + t);
        if (s === y)
          return this.set(y, this.$y + t);
        if (s === M)
          return o(1);
        if (s === T)
          return o(7);
        var f = (n = {}, n[S] = b, n[w] = N, n[p] = L, n)[s] || 1, h = this.$d.getTime() + t * f;
        return a.w(h, this);
      }, e.subtract = function(t, i) {
        return this.add(-1 * t, i);
      }, e.format = function(t) {
        var i = this, n = this.$locale();
        if (!this.isValid())
          return n.invalidDate || J;
        var u = t || "YYYY-MM-DDTHH:mm:ssZ", s = a.z(this), o = this.$H, f = this.$m, h = this.$M, d = n.weekdays, g = n.months, m = function($, D, F, C) {
          return $ && ($[D] || $(i, u)) || F[D].substr(0, C);
        }, Y = function($) {
          return a.s(o % 12 || 12, $, "0");
        }, H = n.meridiem || function($, D, F) {
          var C = $ < 12 ? "AM" : "PM";
          return F ? C.toLowerCase() : C;
        }, O = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: h + 1, MM: a.s(h + 1, 2, "0"), MMM: m(n.monthsShort, h, g, 3), MMMM: m(g, h), D: this.$D, DD: a.s(this.$D, 2, "0"), d: String(this.$W), dd: m(n.weekdaysMin, this.$W, d, 2), ddd: m(n.weekdaysShort, this.$W, d, 3), dddd: d[this.$W], H: String(o), HH: a.s(o, 2, "0"), h: Y(1), hh: Y(2), a: H(o, f, !0), A: H(o, f, !1), m: String(f), mm: a.s(f, 2, "0"), s: String(this.$s), ss: a.s(this.$s, 2, "0"), SSS: a.s(this.$ms, 3, "0"), Z: s };
        return u.replace(q, function($, D) {
          return D || O[$] || s.replace(":", "");
        });
      }, e.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, e.diff = function(t, i, n) {
        var u, s = a.p(i), o = c(t), f = (o.utcOffset() - this.utcOffset()) * b, h = this - o, d = a.m(this, o);
        return d = (u = {}, u[y] = d / 12, u[l] = d, u[U] = d / 3, u[T] = (h - f) / 6048e5, u[M] = (h - f) / 864e5, u[w] = h / N, u[S] = h / b, u[p] = h / L, u)[s] || h, n ? d : a.a(d);
      }, e.daysInMonth = function() {
        return this.endOf(l).$D;
      }, e.$locale = function() {
        return v[this.$L];
      }, e.locale = function(t, i) {
        if (!t)
          return this.$L;
        var n = this.clone(), u = W(t, i, !0);
        return u && (n.$L = u), n;
      }, e.clone = function() {
        return a.w(this.$d, this);
      }, e.toDate = function() {
        return new Date(this.valueOf());
      }, e.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, e.toISOString = function() {
        return this.$d.toISOString();
      }, e.toString = function() {
        return this.$d.toUTCString();
      }, r;
    }(), Z = j.prototype;
    return c.prototype = Z, [["$ms", A], ["$s", p], ["$m", S], ["$H", w], ["$W", M], ["$M", l], ["$y", y], ["$D", _]].forEach(function(r) {
      Z[r[1]] = function(e) {
        return this.$g(e, r[0], r[1]);
      };
    }), c.extend = function(r, e) {
      return r.$i || (r(e, j, c), r.$i = !0), c;
    }, c.locale = W, c.isDayjs = I, c.unix = function(r) {
      return c(1e3 * r);
    }, c.en = v[x], c.Ls = v, c.p = {}, c;
  });
})(z);
var K = z.exports;
const nt = /* @__PURE__ */ Q(K);
export {
  nt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/dayjs@1.10.7/~/dayjs/dayjs.min.js
// module id = 857
// module chunks = 41